import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Modal } from 'reactstrap';
import { connect } from 'react-redux';
import axios from 'axios';
import Cookies from 'js-cookie';
import ReactGA from 'react-ga4';
import { useQuery } from 'utils/helpers';
import * as FS from '@fullstory/browser';
import { notifType, notify } from 'utils/notifSender';
import { useHistory } from 'react-router-dom';

import { ROUTES } from 'config/constants';
import { addItemsToCart } from 'api/cart';
import { clearCart } from 'redux/reducers/cart';
import { handleGetOTPForLogin, handleLogin, handleRegistration, loginModal, handleHideOTP, handleLoginWithOTP, handleCloseSignUp } from 'redux/reducers/auth';
import { checkOTPCode, getOTPForForgotPassword, passwordReset } from 'api/user';
import { trackFreshChatUser, trackKlaviyoEvent } from 'api/tracking';

import Button from '../Button/Button';
import close from 'assets/images/general/close.svg';
import CartItems from './elements/CartItems/CartItems';
import LoginForm from './elements/LoginForm/LoginForm';
import SignUpForm from './elements/SignUpForm/SignUpForm';
import LoginOTPForm from './elements/LoginOTPForm/LoginOTPForm';
import OTPForm from './elements/OTPForm/OTPForm';
import ForgotForm from './elements/ForgotForm/ForgotForm';
import ResetPassword from './elements/ResetPassword/ResetPassword';

import style from './LoginModal.module.scss';

LoginModal.propTypes = {
    isAuthenticating: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired,
    loginModal: PropTypes.func.isRequired,
    handleLogin: PropTypes.func.isRequired,
    handleRegistration: PropTypes.func.isRequired,
    handleGetOTPForLogin: PropTypes.func,
    showOTP: PropTypes.bool,
    handleHideOTP: PropTypes.func,
    handleLoginWithOTP: PropTypes.func,
    signUp: PropTypes.bool,
    handleCloseSignUp: PropTypes.func,
    clearCart: PropTypes.func.isRequired,
    product: PropTypes.any,
    profile: PropTypes.any,
    isReset: PropTypes.bool,
    resetEmail: PropTypes.string,
    toggleModal: PropTypes.func
};

function LoginModal({
    isOpen,
    loginModal,
    handleLogin,
    isAuthenticating,
    handleRegistration,
    handleGetOTPForLogin,
    showOTP,
    handleHideOTP,
    handleLoginWithOTP,
    signUp,
    handleCloseSignUp,
    clearCart,
    profile,
    isReset,
    resetEmail,
    toggleModal
}) {
    const history = useHistory();
    const query = useQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const products = localStorage.getItem('products') ? JSON.parse(localStorage.getItem('products')) : [];
    const [form, setForm] = useState('signin');
    const [loginWithPhone, setLoginWithPhone] = useState('');
    const [timer, setTimer] = useState(90);
    const [loading, setLoading] = useState(false);
    const [forgotOtp, setForgotOtp] = useState(false);
    const [emailAddress, setEmailAddress] = useState(isReset ? resetEmail : '');
    const [otp, setOtp] = useState('');
    const [lastnumber, setLastnumber] = useState('');
    const [ip, setIP] = useState(null);
    const [doRegister, setDoRegister] = useState(false);
    const [doLogin, setDoLogin] = useState(false);

    // creating function to load ip address from the API
    useEffect(() => {
        if (profile?.singpass_status === 'verified' && form !== 'signin') {
            history.push(ROUTES.SINGPASS);
        } else {
            // passing getData method to the lifecycle method
            const getData = async () => {
                try {
                    const res = await axios.get('https://geolocation-db.com/json/');

                    setIP(res.data.IPv4);
                } catch (error) {
                    //
                }
            };

            getData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, profile?.singpass_status]);

    useEffect(() => {
        const forgot = query.get('forgot');

        if (forgot && forgot === 'true') {
            // show login modal and change form to forgot password form
            handleChangeForm('forgot');
        }
    }, [query]);

    useEffect(() => {
        if (isReset) {
            setForm('loginOtp');
        }
    }, [isReset]);

    useEffect(() => {
        if (showOTP || forgotOtp) {
            const time = setTimeout(() => {
                if (timer > 0) {
                    setTimer(timer - 1);
                }
            }, 1000);

            return () => clearTimeout(time);
        } else {
            setTimer(90);
        }
    }, [forgotOtp, showOTP, timer]);

    useEffect(() => {
        if (signUp) {
            setForm('signup');
        }
    }, [signUp]);

    const handleLoginWithPhone = e => {
        setLoginWithPhone(e);

        if (e.length > 2) {
            setLastnumber(e.slice(-2));
        }
    };

    const handleChangeForm = e => setForm(e);

    const submitLogin = async (params) => {
        handleLogin({
            ...params,
            gaSessionId: Cookies.get('_ga') || 'no-session',
            trueIp: ip || 'no-ip',
            onSuccess: () => {
                setDoLogin(true);

                if (window.location.pathname === '/products') {
                    window.location.reload();
                }
            }
        });
    };

    const submitSignUp = async (params) => {
        handleRegistration({
            ...params,
            gaSessionId: Cookies.get('_ga') || 'no-session',
            trueIp: ip || 'no-ip',
            onSuccess: () => {
                setDoRegister(true);
            },
            onFailure: () => {
                notify('Error ! try again', notifType.DANGER);
            }
        });
    };

    useEffect(() => {
        async function sendProductsToBE() {
            const makeProducts = [];

            for (const product of products) {
                makeProducts.push(
                    {
                        is_purchase: false,
                        product_attribute_value_id: product.selectedStorage ? product.selectedStorage.value
                            : (
                                product.attributes.specifications.values[0].id ||
                                product.attributes.inside_box.values[0].id
                            ),
                        quantity: 1,
                        rental_period_id: product.selectedRentalPeriod.id,
                        rental_period_duration: product?.selectedRentalPeriod?.duration_time,
                        product_id: product.id,
                        color_id: product.selectedColor.value,
                        deal_id: null
                    }
                );
            }

            try {
                await addItemsToCart(makeProducts);

                notify(`Product${makeProducts.length > 1 ? 's' : ''} added to cart successfuly`, notifType.SUCCESS);
                clearCart();
                history.push(ROUTES.CART);
            } catch (err) {
                //
            }
        }

        if (profile.id && doRegister) {
            ReactGA.event('user_register', {
                category: 'user_auth',
                label: 'user_register',
                value: profile.id,
                user_ID: profile.id,
                fp: Cookies.get('_fp'),
                timestamp: new Date()
            });

            FS.event('User registered', {
                user_id: profile.id.toString()
            });

            trackKlaviyoEvent('identify', profile);

            trackFreshChatUser('identify', profile);
        }

        if (profile.id && doLogin) {
            // add google event here for signin
            ReactGA.event('user_login', {
                category: 'user_auth',
                label: 'user_login',
                value: profile.id,
                user_ID: profile.id,
                fp: Cookies.get('_fp'),
                timestamp: new Date()
            });

            if (products.length !== 0) {
                if (profile.singpass_status !== 'verified') {
                    // check if user can add to cart
                    notify('Please complete your Singpass profile before proceeding.', notifType.DANGER);
                    clearCart();

                    history.push(ROUTES.MYINFORMATION);
                } else {
                    sendProductsToBE();
                }
            }

            FS.event('User login', {
                user_id: profile.id.toString()
            });

            trackKlaviyoEvent('identify', profile);

            trackFreshChatUser('identify', profile);
        }
    }, [profile, doRegister, doLogin, clearCart, history, products]);

    const submitForgotPassword = async (email) => {
        setLoading(true);
        setEmailAddress(email);

        getOTPForForgotPassword(email,
            () => {
                setForgotOtp(true);
                setForm('reset');
            },
            () => {
                notify('Error ! Invalid email used', notifType.DANGER);
            });

        setLoading(false);
    };

    const handleSubmitLoginWithPhone = async () => {
        if (loginWithPhone === '') {
            notify('Error ! Enter your mobile number', notifType.DANGER);

            return true;
        }

        setOtp('');
        handleGetOTPForLogin(loginWithPhone);
    };

    const handleShowLoginWithOTP = () => {
        setForm('loginOtp');
        handleHideOTP();
    };

    const handleResendCode = () => {
        if (timer > 0) {
            notify(`Error ! after ${timer} seconds you can resend SMS again`, notifType.DANGER);

            return true;
        }

        setOtp('');
        handleGetOTPForLogin(loginWithPhone);
        setTimer(90);
    };

    const handleSubmitOtp = async (type) => {
        if (type === 'login' && !isReset) {
            handleLoginWithOTP({ otp });
            setOtp('');
        }

        if (isReset || type === 'forgot') {
            setLoading(true);

            try {
                await checkOTPCode(otp,
                    () => {
                        setForgotOtp(false);

                        if (isReset) {
                            setForm('reset');
                        }
                    },
                    () => {
                        notify('Error ! OTP code is wrong!', notifType.DANGER);
                    });
            } catch (error) {
                if (error.response.status) {
                    notify('Error ! OTP code is wrong!', notifType.DANGER);
                }
            }

            setLoading(false);
        }
    };

    const submitResetPassword = async password => {
        setLoading(true);

        try {
            await passwordReset(
                {
                    otp_code: otp,
                    password,
                    password_confirmation: password
                },
                () => {
                    onPasswordResetSuccess();
                },
                () => {
                    onPasswordResetFailure();
                }
            );
        } catch (error) {
            if (error.response.status) {
                onPasswordResetFailure();
            }
        }

        setLoading(false);
    };

    const onPasswordResetSuccess = () => {
        notify('Password changed successfuly!', notifType.SUCCESS);
        setForm('signin');
        setForgotOtp(false);

        if (isReset) {
            toggleModal();
        }

        setOtp('');
    };

    const onPasswordResetFailure = () => {
        notify('Error ! try again', notifType.DANGER);
    };

    return (
        <Modal isOpen={isOpen} className={style.modal}>
            <div className={style.section}>
                <div className={style.header}>
                    <div className={style.header__title}>
                        {products.length !== 0 ? 'Your Cart' : ''}
                    </div>
                    <div className={style.header__close}>
                        <img className={style.header__close__img}
                            onClick={isReset ? () => { toggleModal(); handleCloseSignUp(); loginModal(false); setForm('signin'); } : () => { handleCloseSignUp(); loginModal(false); setForm('signin'); }}
                            src={close}
                            alt='close' />
                    </div>
                </div>

                {products.length !== 0 &&
                    <div>
                        <CartItems products={products} />
                    </div>}

                <div className={style.forms}>
                    {!isReset && (form === 'signin' || form === 'signup' || form === 'loginOtp') &&
                        <div className={style.formsBtns}>
                            <div className={style.formsBtns__col}>
                                <Button
                                    title={'SignIn'}
                                    className={(form === 'signin' || form === 'loginOtp')
                                        ? style.active + ' ' + style.button
                                        : style.button + ' ' + style.inActive}
                                    onClick={() => { setForm('signin'); setOtp(''); }} />
                            </div>
                            <div className={style.formsBtns__col}>
                                <Button
                                    title={'Sign Up'}
                                    className={form === 'signup'
                                        ? style.active + ' ' + style.button
                                        : style.button + ' ' + style.inActive}
                                    onClick={() => { setForm('signup'); setOtp(''); }} />
                            </div>
                        </div>
                    }
                    <div>
                        {form === 'signin' &&
                            <LoginForm
                                showLoginWithOTP={handleShowLoginWithOTP}
                                submit={submitLogin}
                                changeForm={handleChangeForm}
                                loading={isAuthenticating} />
                        }

                        {form === 'signup' &&
                            <SignUpForm
                                submit={submitSignUp}
                                changeForm={handleChangeForm}
                                loading={isAuthenticating} />}

                        {(form === 'loginOtp' && !showOTP && !isReset) &&
                            <LoginOTPForm
                                phone={loginWithPhone}
                                setPhone={handleLoginWithPhone}
                                submit={handleSubmitLoginWithPhone}
                                changeForm={handleChangeForm}
                                loading={isAuthenticating} />

                        }
                        {(form === 'loginOtp' && (showOTP || isReset)) &&
                            <OTPForm
                                lastnumber={lastnumber}
                                otp={otp}
                                setOtp={setOtp}
                                type='login'
                                resendCode={handleResendCode}
                                timer={timer}
                                submit={handleSubmitOtp}
                                changeForm={handleChangeForm}
                                email={emailAddress}
                                isReset={isReset}
                                loading={isAuthenticating} />}

                        {form === 'forgot' &&
                            <ForgotForm
                                submit={submitForgotPassword}
                                changeForm={handleChangeForm}
                                loading={loading} />}

                        {form === 'reset' && !forgotOtp &&
                            <ResetPassword
                                submit={submitResetPassword}
                                changeForm={handleChangeForm}
                                isReset={isReset}
                                loading={loading} />}

                        {form === 'reset' && forgotOtp &&
                            <OTPForm
                                lastnumber={lastnumber}
                                otp={otp}
                                setOtp={setOtp}
                                email={emailAddress}
                                type={'forgot'}
                                resendCode={handleResendCode}
                                timer={timer}
                                submit={handleSubmitOtp}
                                changeForm={handleChangeForm}
                                loading={loading} />}
                    </div>
                </div>
            </div>
        </Modal>
    );
}

function mapStateToProps({ cart, auth }) {
    const { products, product } = cart;
    const { isAuthenticating, showOTP, signUp, profile } = auth;

    return {
        products: JSON.parse(products),
        isAuthenticating,
        showOTP,
        signUp,
        product,
        profile
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loginModal: (openLogin) => {
            dispatch(loginModal(openLogin));
        },
        handleLogin: ({
            email,
            password,
            isRemember,
            gaSessionId,
            trueIp,
            onSuccess
        }) => {
            dispatch(handleLogin({
                email,
                password,
                isRemember,
                gaSessionId,
                trueIp,
                onSuccess
            }));
        },
        handleRegistration: ({
            // name,
            // surname,
            // phone,
            email,
            password,
            confirmPassword,
            gaSessionId,
            trueIp,
            onSuccess,
            onFailure
        }) => {
            dispatch(handleRegistration({
                // name,
                // surname,
                // phone,
                email,
                password,
                confirmPassword,
                gaSessionId,
                trueIp,
                onSuccess,
                onFailure
            }));
        },
        handleGetOTPForLogin: (phone) => {
            dispatch(handleGetOTPForLogin({
                phone
            }));
        },
        handleHideOTP: () => { dispatch(handleHideOTP()); },
        handleLoginWithOTP: ({ otp }) => { dispatch(handleLoginWithOTP({ otp })); },
        handleCloseSignUp: () => { dispatch(handleCloseSignUp()); },
        clearCart: () => dispatch(clearCart())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginModal);
